import React, { FC, useState } from 'react'

import { USAGE_METRIC, USAGE_METRIC_META } from 'constants/usageLimits'

import RequestCarePlanAuditAccessModal from './RequestCarePlanAuditAccessModal'
import * as S from './UsageMeter.style'

interface Props {
  botId: string | number
  canRequestIncrease?: boolean
}

const CarePlanAuditGlyph: FC = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M9 4h6a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 5h1a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h1"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9 14l2 2 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

/**
 * Shown in place of the Care Plan Audit meter when the organisation's package
 * does not include it: why the feature is absent and a way to request it.
 */
export const CarePlanAuditUnavailableCard: FC<Props> = ({ botId, canRequestIncrease = true }) => {
  const [requestOpen, setRequestOpen] = useState(false)

  const label = USAGE_METRIC_META[USAGE_METRIC.CARE_PLAN_AUDITS]?.label || 'Care plan audits'

  return (
    <S.MeterCard>
      <S.MeterCardBody>
        <S.CardHead>
          <S.CardHeadLeft>
            <S.MeterIcon>
              <CarePlanAuditGlyph />
            </S.MeterIcon>
            <S.MeterIdentity>
              <S.MeterLabel>{label}</S.MeterLabel>
            </S.MeterIdentity>
          </S.CardHeadLeft>
        </S.CardHead>

        <S.UnavailableText>
          Care Plan Audit isn&rsquo;t part of this organisation&rsquo;s current package.
          {canRequestIncrease && ' Request it and your admin will follow up to add it.'}
        </S.UnavailableText>
      </S.MeterCardBody>

      {canRequestIncrease && (
        <S.RequestButton onClick={() => setRequestOpen(true)}>Request care plan audit</S.RequestButton>
      )}

      {canRequestIncrease && requestOpen && (
        <RequestCarePlanAuditAccessModal open={requestOpen} onClose={() => setRequestOpen(false)} botId={botId} />
      )}
    </S.MeterCard>
  )
}

export default CarePlanAuditUnavailableCard
